import { useState, useEffect } from 'react';
import { List } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { profileService } from '@/services';
import { picklists, PicklistConfig } from '@/config/picklists';
import PicklistSelector from './PicklistSelector';
import PicklistValuesTable from './PicklistValuesTable';

export default function PicklistManager() {
  const { user } = useAuth();
  const [selectedPicklist, setSelectedPicklist] = useState<PicklistConfig | null>(
    picklists[0] || null
  );
  const [companyId, setCompanyId] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanyId = async () => {
      if (!user) return;

      const { data: profile } = await profileService.get(user.id);

      if (profile?.company_id) {
        setCompanyId(profile.company_id);
      }
    };

    fetchCompanyId();
  }, [user]);

  if (!companyId) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        <p>Please set up your company profile first.</p>
      </div>
    );
  }

  return (
    <div className="flex border border-border rounded-lg overflow-hidden bg-card h-[600px]">
      {/* Left sidebar - Picklist selector */}
      <div className="w-64 border-r border-border flex-shrink-0">
        <PicklistSelector
          picklists={picklists}
          selectedId={selectedPicklist?.id || null}
          onSelect={setSelectedPicklist}
        />
      </div>

      {/* Right content - Values table */}
      <div className="flex-1 p-6 overflow-auto">
        {selectedPicklist ? (
          <PicklistValuesTable picklist={selectedPicklist} companyId={companyId} />
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
            <List className="w-12 h-12 mb-4" />
            <p>Select a picklist to manage its values</p>
          </div>
        )}
      </div>
    </div>
  );
}
